import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { LoginResponseModel } from '../../_models/index';
import { BaseProvider } from '../BaseProvider';
import * as moment from 'moment';
import { GlobalService } from '../../_global/global.service';
import { TicketRequestModel } from '../../_models/ticketreplymodel';

@Injectable()
export class DashboardService extends BaseProvider {
    model: any = {};
    resource = 'reports/';
    resourceUrl = 'getAllTicketsWithExcelReport';
    thisMonthStartDate: string = moment().format('YYYY-MM') + '-01';
    thisMonthEndDate: string = moment().format('YYYY-MM-DD');
    getTicketFilter = 'getAllTickets';

    constructor(private http: Http, private _gs: GlobalService) {
        super(http);
    }

    getLeadConversions() { // login an partner employee with credentials
        const url: string = this.resource + 'leadConversion?scope=partner' +
            '&partnerId=' + this._gs.currentUser.partner.id +
            '&startDate=' + this.thisMonthStartDate +
            '&endDate=' + this.thisMonthEndDate;
        return this.makeGetCall(url);
    }

    getRevenueSummary() { // login an partner employee with credentials
        const url: string = this.resource + 'revenueSummary?scope=partner' +
            '&partnerId=' + this._gs.currentUser.partner.id +
            '&startDate=' + this.thisMonthStartDate +
            '&endDate=' + this.thisMonthEndDate;
        return this.makeGetCall(url);
    }
    // TICKETS API

    getAllTickets(downLoadreport) {
        var resourceUrl = "getAllTicketsWithExcelReport?downloadReport=" + downLoadreport;
        return this.makeGetCall(resourceUrl);
    }
    getSubjectList() {
        return this.makeGetCall('ticketSubjects');
    }
    getFilteredTickets(uiChannel, status, startDate, endDate, subject, downLoadreport) {

        if (status != -1 && subject != -1 && uiChannel != -1) {
            const url: string = this.resourceUrl + '?downloadReport=' + downLoadreport +
                '&endDate=' + endDate +
                '&startDate=' + startDate +
                '&status=' + status +
                '&subject=' + subject + '&uiChannel=' + uiChannel
            return this.makeGetCall(url);
        }
        else if (status != -1 && uiChannel != -1) {
            const url: string = this.resourceUrl + '?downloadReport=' + downLoadreport +
                '&endDate=' + endDate +
                '&startDate=' + startDate +
                '&status=' + status +
                '&uiChannel=' + uiChannel
            return this.makeGetCall(url);
        }
        else if (uiChannel != -1 && subject != -1) {
            const url: string = this.resourceUrl + '?downloadReport=' + downLoadreport +
                '&endDate=' + endDate +
                '&startDate=' + startDate +
                '&uiChannel=' + uiChannel +
                '&subject=' + subject
            return this.makeGetCall(url);
        }
        else if (status != -1 && subject != -1) {
            const url: string = this.resourceUrl + '?downloadReport=' + downLoadreport +
                '&endDate=' + endDate +
                '&startDate=' + startDate +
                '&status=' + status +
                '&subject=' + subject
            return this.makeGetCall(url);
        }
        else if (uiChannel != -1) {
            const url: string = this.resourceUrl + '?downloadReport=' + downLoadreport +
                '&endDate=' + endDate +
                '&startDate=' + startDate +
                '&uiChannel=' + uiChannel

            return this.makeGetCall(url);
        }
        else if (status != -1) {
            const url: string = this.resourceUrl + '?downloadReport=' + downLoadreport +
                '&endDate=' + endDate +
                '&startDate=' + startDate +
                '&status=' + status

            return this.makeGetCall(url);
        }
        else if (subject != -1) {
            const url: string = this.resourceUrl + '?downloadReport=' + downLoadreport +
                '&endDate=' + endDate +
                '&startDate=' + startDate +
                '&subject=' + subject
            return this.makeGetCall(url);
        }
        else {
            const url: string = this.resourceUrl + '?downloadReport=' + downLoadreport +
                '&endDate=' + endDate +
                '&startDate=' + startDate
            return this.makeGetCall(url);
        }

    }
    getSecuDashTikcets(status) {
        const url: string = this.resourceUrl + '?status=' + status

        return this.makeGetCall(url);
    }
    getSecuDashData(startDate, endDate) {
        const url: string = 'dashboard/secuSmart?startDate=' + startDate + '&endDate=' + endDate;
        return this.makeGetCall(url);
    }

    getSingleTickets(ticketId) {
        var resourceUrl = 'getTicketDetails?ticketId=' + ticketId;
        return this.makeGetCall(resourceUrl);
    }
    getOrderTicketDetails(orderId) {
        var resourceUrl = 'orderTicketDetails?orderId=' + orderId;
        return this.makeGetCall(resourceUrl);
    }

    //comment section for tickets API
    addNewTicketAndResponce(request: TicketRequestModel) {
        var resourceUrl = "adminTicketResponse?comment=" +
            request.comment +
            "&subject=" +
            request.subject + "&primaryTicketId=" + request.primaryTicketId + "&status=" + request.status;

        return this.makePostCall(resourceUrl, request);
    }

    getGlobalRanking() { // login an partner employee with credentials
        const url: string = this.resource + 'globalRanking?scope=partner' +
            '&partnerId=' + this._gs.currentUser.partner.id +
            '&startDate=' + this.thisMonthStartDate +
            '&endDate=' + this.thisMonthEndDate;
        return this.makeGetCall(url);
    }
    getFunnelReport() { // login an partner employee with credentials
        const url: string = this.resource + 'leadFunnel?startDate=' + this.thisMonthStartDate +
            '&endDate=' + this.thisMonthEndDate + '&partnerId=' + this._gs.currentUser.partner.id;
        return this.makeGetCall(url);
    }
    getDynamicReport() {
        return this.makeGetCall('reports' + '?partnerId=' + this._gs.currentUser.partner.id);
        //return this.makeGetCall('reports');
    }
    getStates() {
        return this.makeGetCall('states', null);
    }
    getSupportReports() {
        return this.makeGetCall('supportApi' + '?userId=' + this._gs.currentUser.id);
    }
    getSupportReportData(reportId, pan, passport, startDate, endDate) {
        const url: string = 'supportApi/getApiData' + '?passport=' + passport
            + '&supportAccessApiId=' + reportId + (pan != null ? ('&pan=' + pan) : "")
        return this.makeGetCall(url);
    }
    getDynamicReportsData(reportId, startDate, endDate, partnerId, branchId, product,
        leadStatus, orderStatus, state, paymentType, partnerType?, partnerStatus?) {
        const url: string = 'reports/getReport?' +
            'reportId=' + reportId +
            '&startDate=' + startDate +
            '&endDate=' + endDate +
            (partnerId != -1 ? ('&partnerId=' + partnerId) : "") +
            (branchId != -1 ? ('&branchId=' + branchId) : "") +
            (leadStatus != -1 ? ('&consumerLeadStatus=' + leadStatus) : "") +
            (orderStatus != -1 ? ('&orderStatus=' + orderStatus) : "") +
            (product != -1 ? ('&product=' + product) : "") +
            (state != -1 ? ('&state=' + state) : "") +
            (paymentType != -1 ? ('&paymentType=' + paymentType) : "") +
            (partnerType != null && partnerType != -1 ? ('&partnerType=' + partnerType) : "") +
            (partnerStatus != null && partnerStatus != -1 ? ('&partnerStatus=' + partnerStatus) : "")
        return this.makeGetCall(url);

    }
    getConsumersList() {
        const url: string = 'consumers'
        return this.makeGetCall(url);
    }
    getConsumerList(startDate, endDate, vcipStatus, profileStatus, consumerAmlCheckStatus, consumerPassportVerificationStatus, consumerPanStatus, pageNumber, recordPerPage, searchKeyword, exportRecords, totalRecords) {
        const url: string = 'consumersList' +
            (startDate != -1 ? ('?startDate=' + startDate) : "") +
            (endDate != -1 ? ('&endDate=' + endDate) : "") +
            (vcipStatus != -1 ? ('&vcipStatus=' + vcipStatus) : "") +
            (profileStatus != -1 ? ('&profileStatus=' + profileStatus) : "") +
            (consumerAmlCheckStatus != -1 ? ('&consumerAmlCheckStatus=' + consumerAmlCheckStatus) : "") +
            (consumerPassportVerificationStatus != -1 ? ('&consumerPassportVerificationStatus=' + consumerPassportVerificationStatus) : "") +
            (consumerPanStatus != -1 ? ('&consumerPanStatus=' + consumerPanStatus) : "") +
            (pageNumber != -1 ? ('&pageNumber=' + pageNumber) : "") +
            (recordPerPage != -1 ? ('&recordPerPage=' + recordPerPage) : "") +
            (searchKeyword != -1 ? ('&searchKeyword=' + searchKeyword) : "") +
            (exportRecords != -1 ? ('&exportRecords=' + exportRecords) : "") +
            (totalRecords != -1 ? ('&totalRecords=' + totalRecords) : "")

        return this.makeGetCall(url);
    }

    // getConsumerList2(startDate, endDate, vcipStatus, profileStatus, consumerAmlCheckStatus, consumerPassportVerificationStatus, consumerPanStatus, pageNumber, recordPerPage, searchKeyword) {
    //     const url: string = 'consumers' +
    //         (startDate != -1 ? ('?startDate=' + startDate) : "") +
    //         (endDate != -1 ? ('&endDate=' + endDate) : "") +
    //         (vcipStatus != -1 ? ('&vcipStatus=' + vcipStatus) : "") +
    //         (profileStatus != -1 ? ('&profileStatus=' + profileStatus) : "") +
    //         (consumerAmlCheckStatus != -1 ? ('&consumerAmlCheckStatus=' + consumerAmlCheckStatus) : "") +
    //         (consumerPassportVerificationStatus != -1 ? ('&consumerPassportVerificationStatus=' + consumerPassportVerificationStatus) : "") +
    //         (consumerPanStatus != -1 ? ('&consumerPanStatus=' + consumerPanStatus) : "") +
    //         (pageNumber != -1 ? ('&pageNumber=' + pageNumber) : "") +
    //         (recordPerPage != -1 ? ('&recordPerPage=' + recordPerPage) : "") +
    //         (searchKeyword != -1 ? ('&searchKeyword=' + searchKeyword) : "")
    //     return this.makeGetCall(url);
    // }

    consumerExport(startDate, endDate, vcipStatus, profileStatus, consumerAmlCheckStatus, consumerPassportVerificationStatus, consumerPanStatus, pageNumber, pageSize, searchKeyword) {
        const url: string = 'consumersExport' +
            (startDate != -1 ? ('?startDate=' + startDate) : "") +
            (endDate != -1 ? ('&endDate=' + endDate) : "") +
            (vcipStatus != -1 ? ('&vcipStatus=' + vcipStatus) : "") +
            (profileStatus != -1 ? ('&profileStatus=' + profileStatus) : "") +
            (consumerAmlCheckStatus != -1 ? ('&consumerAmlCheckStatus=' + consumerAmlCheckStatus) : "") +
            (consumerPassportVerificationStatus != -1 ? ('&consumerPassportVerificationStatus=' + consumerPassportVerificationStatus) : "") +
            (consumerPanStatus != -1 ? ('&consumerPanStatus=' + consumerPanStatus) : "") +
            (pageNumber != -1 ? ('&pageNumber=' + pageNumber) : "") +
            (pageSize != -1 ? ('&pageSize=' + pageSize) : "") +
            (searchKeyword != -1 ? ('&searchKeyword=' + searchKeyword) : "")
        return this.makeGetCall(url);
    }

    getConsumerListBySearch(searchId) {
        return this.makeGetCall("getConsumerBySearch?searchId=" + searchId);
    }

    outstandingPaymentOrders(reportId, partnerId) {
        const url2: string = 'reports/getReport' + '?reportId=' + reportId +
            '&partnerId=' + partnerId

        return this.makeGetCall(url2);
    }
    getProductWiseRevenueSummary(startDate, endDate, partnerId, branchId, product, index) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }

        if (branchId != -1 && product != -1) {
            const url: string = this.resource + 'partnerProductWiseRevenueByBranchByDate?' +
                'partnerId=' + partnerId +
                '&branchId=' + branchId +
                '&product=' + product +
                '&startDate=' + startDate +
                '&endDate=' + endDate
            return this.makeGetCall(url);
        } else if (branchId != -1) {
            const url: string = this.resource + 'partnerProductWiseRevenueByBranchByDate?' +
                'partnerId=' + partnerId +
                '&branchId=' + branchId +
                '&startDate=' + startDate +
                '&endDate=' + endDate
            return this.makeGetCall(url);
        } else if (product != -1 && product != -2) {
            const url: string = this.resource + 'partnerProductWiseRevenueByBranchByDate?' +
                'partnerId=' + partnerId +
                '&product=' + product +
                '&startDate=' + startDate +
                '&endDate=' + endDate
            return this.makeGetCall(url);
        } else {
            const url: string = this.resource + 'partnerProductWiseRevenueByBranchByDate?' +
                'partnerId=' + partnerId +
                '&startDate=' + startDate +
                '&endDate=' + endDate
            return this.makeGetCall(url);
        }



    }
    getDynamicReportsDataForPartner(reportId, startDate, endDate, partnerId, product, leadStatus, orderStatus, state, paymentType) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }

        switch (reportId) {
            case 'RP_LEAD_STATUS':
                if (leadStatus != -1) {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&branchId=' + this._gs.currentUser.branch.id +
                        '&consumerLeadStatus=' + leadStatus + '&startDate=' + startDate +
                        '&endDate=' + endDate;

                    return this.makeGetCall(url);
                } else {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&branchId=' + this._gs.currentUser.branch.id + '&startDate=' + startDate +
                        '&endDate=' + endDate
                    return this.makeGetCall(url);
                }
            // break;
            case 'RP_LOCATION_WISE':
                if (product != -1) {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate +
                        '&product=' + product + '&branchId=' + this._gs.currentUser.branch.id
                    return this.makeGetCall(url);
                } else {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate + '&branchId=' + this._gs.currentUser.branch.id
                    return this.makeGetCall(url);
                }
            case 'RP_LOCATION_WISE_NESTED':
                if (product != -1) {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate +
                        '&product=' + product + '&branchId=' + this._gs.currentUser.branch.id
                    return this.makeGetCall(url);
                } else {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate + '&branchId=' + this._gs.currentUser.branch.id
                    return this.makeGetCall(url);
                }

            case 'RP_ORDER_WISE_REVENUE':
                if (product != -1) {
                    const url: string = 'reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&branchId=' + this._gs.currentUser.branch.id + '&startDate=' + startDate +
                        '&endDate=' + endDate +
                        '&product=' + product
                    return this.makeGetCall(url);
                } else {
                    const url: string = 'reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate + '&branchId=' + this._gs.currentUser.branch.id
                    return this.makeGetCall(url);
                }

            case 'RP_ORDER_STATUS':

                if (orderStatus != -1) {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate +
                        '&orderStatus=' + orderStatus + '&branchId=' + this._gs.currentUser.branch.id
                    return this.makeGetCall(url);
                } else {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate +
                        '&branchId=' + this._gs.currentUser.branch.id
                    return this.makeGetCall(url);
                }



            case 'RP_PARTNER_TRANSACTIONS':
                if (state != -1) {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate +
                        '&stateId=' + state
                    return this.makeGetCall(url);
                } else {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate

                    return this.makeGetCall(url);
                }
            case 'RP_STATEWISE_AGENT_COMMISSION':
                if (state != -1) {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate +
                        '&stateId=' + state
                    return this.makeGetCall(url);
                } else {
                    const url: string = '/reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate

                    return this.makeGetCall(url);
                }
            case 'RP_PARTNER_COMMISSION_TRANSACTIONS':
                if (paymentType != -1) {
                    const url2: string = 'reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&paymentType=' + paymentType + '&startDate=' + startDate +
                        '&endDate=' + endDate
                    return this.makeGetCall(url2);
                } else {
                    const url2: string = 'reports/getReport' + '?reportId=' + reportId +
                        '&partnerId=' + partnerId + '&startDate=' + startDate +
                        '&endDate=' + endDate
                    return this.makeGetCall(url2);
                }



            default:
                const url3: string = 'reports/getReport' + '?reportId=' + reportId +
                    '&partnerId=' + partnerId

                return this.makeGetCall(url3);
        }
    }
    getProductWiseRevenueSummaryWithBranch(startDate, endDate, partnerId) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        const url: string = this.resource + 'partnerProductWiseRevenueByBranchByDate?' +
            'partnerId=' + partnerId +
            '&startDate=' + startDate +
            '&endDate=' + endDate + '&branchId=' + this._gs.currentUser.branch.id;;
        return this.makeGetCall(url);


    }
    getProductWiseRevenueSummaryWithSummary(startDate, endDate, orderStatus, partnerId, isBranchId) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (isBranchId) {
            const url: string = this.resource + 'partnerProductWiseRevenueByBranchByDate?' +
                'partnerId=' + partnerId +
                '&startDate=' + startDate +
                '&endDate=' + endDate +
                '&orderStatus=' + orderStatus + '&branchId=' + this._gs.currentUser.branch.id;
            return this.makeGetCall(url);

        } else {
            const url: string = this.resource + 'partnerProductWiseRevenueByBranchByDate?' +
                'partnerId=' + partnerId +
                '&startDate=' + startDate +
                '&endDate=' + endDate +
                '&orderStatus=' + orderStatus;
            return this.makeGetCall(url);

        }


    }
}



// WEBPACK FOOTER //
// ./src/app/_services/dashboard/dashboard.service.ts